/** @file ikDot: dot product of two vectors (private stand-in for math M1 vec3Dot until it lands). */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** `a . b`. */
export function ikDot(a: Vec3, b: Vec3): number {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
